import type * as React from 'react';
const SvgIcoMetrics = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M17.25 5a2.75 2.75 0 1 1 5.5 0v14a2.75 2.75 0 1 1-5.5 0zM20 3.75c-.69 0-1.25.56-1.25 1.25v14a1.25 1.25 0 1 0 2.5 0V5c0-.69-.56-1.25-1.25-1.25M9.25 10.684a2.75 2.75 0 1 1 5.5 0V19a2.75 2.75 0 1 1-5.5 0zM12 9.434c-.69 0-1.25.56-1.25 1.25V19a1.25 1.25 0 1 0 2.5 0v-8.316c0-.69-.56-1.25-1.25-1.25M1.25 16.368a2.75 2.75 0 1 1 5.5 0V19a2.75 2.75 0 1 1-5.5 0zM4 15.118c-.69 0-1.25.56-1.25 1.25V19a1.25 1.25 0 1 0 2.5 0v-2.632c0-.69-.56-1.25-1.25-1.25" />
    </g>
  </svg>
);
export default SvgIcoMetrics;
